import React from 'react';
import { Link } from 'react-router-dom';

export interface QuickLink {
  to: string;
  label: string;
  icon: React.ReactNode;
  description?: string;
}

export default function QuickLinks({ links, title = 'Quick Links' }: { links: QuickLink[]; title?: string }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="group flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-primary/60 hover:bg-primary/5 transition-colors"
          >
            <span className="text-primary shrink-0 group-hover:scale-110 transition-transform">{l.icon}</span>
            <div className="min-w-0">
              <p className="font-medium text-sm text-gray-800 group-hover:text-primary leading-tight">{l.label}</p>
              {l.description && <p className="text-xs text-gray-500 truncate">{l.description}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}